<div id="already-sent-gift">
  <div *ngIf="! customMessage; else elseBlock" class="db-error-section">
    <p>{{'SUCCESS_TRANSACT' | translate}}</p>
  </div>
  <ng-template #elseBlock>
    <div [innerHTML]="(customMessage || '') | safeHtml" class="db-error-section">
      {{ customMessage }}
    </div>
  </ng-template>
</div>
